import { useEffect, useState } from 'react';
import './pacotes-pontos.component.scss';
import '../loja-component.scss';
import { useNavigate } from 'react-router-dom';
import { MercadoPago_Produtos_ParametrizadosDTO } from '../../../dtos/MercadoPago_Produtos_ParametrizadosDTO';
import { buscarProdutosParametrizados } from '../../../services/busca-produtos-parametrizados';
import { solicitarCompraProduto } from '../../../services/solicita-compra-produto';
import { RespostaSolicitacaoCompraDTO } from '../../../dtos/RespostaSolicitacaoCompraDTO';
import { checkoutCompra } from '../../../services/checkout-produto';
import { alertService } from '../../../services/alertService';
import { useTranslation } from 'react-i18next';

const PacotesPontosComponent = () => {

    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const [produtos, setProdutos] = useState<Array<MercadoPago_Produtos_ParametrizadosDTO>>([]);
    const [carregouProdutos, setCarregouProdutos] = useState(false);
    const [carregouProdutoAposClick, setCarregouProdutoAposClick] = useState(false);

    useEffect(() => {
        buscarProdutosParametrizados()
            .then((resposta) => {
                setProdutos(resposta);
                setCarregouProdutos(true);
            })
            .catch(() => {
                alertService.toast(t("PACKAGES_FETCH_ERROR"), 'error');
            });
    }, [t]);

    function solicitarCompra(produto: MercadoPago_Produtos_ParametrizadosDTO) {

        setCarregouProdutoAposClick(true);

        solicitarCompraProduto(produto)
            .then((resposta: RespostaSolicitacaoCompraDTO) => {
                checkoutCompra(resposta)
                    .catch(() => alert(t("PACKAGES_CHECKOUT_ERROR")))
                    .finally(() => habilitarBotao());
            })
            .catch(() => {
                alert(t("PACKAGES_REQUEST_ERROR"));
                habilitarBotao();
            });

        function habilitarBotao() {
            setTimeout(() => setCarregouProdutoAposClick(false), 1000);
        }
    }

    const obterProdutoMaisVantajoso = () => {
        let melhor: any = null;
        let melhorCusto = Infinity;
        for (const p of produtos) {
            const custo = p.Preco / p.TotalPontos;
            if (custo < melhorCusto) {
                melhorCusto = custo;
                melhor = p;
            }
        }
        return melhor;
    };

    const melhorPacote = obterProdutoMaisVantajoso();

    const tooltipPorPacote = (titulo: string) => {
        if (titulo.includes('Básico')) return t("PACKAGES_TOOLTIP_BASIC");
        if (titulo.includes('Médio')) return t("PACKAGES_TOOLTIP_MEDIUM");
        if (titulo.includes('Avançado')) return t("PACKAGES_TOOLTIP_ADVANCED");
        return t("PACKAGES_TOOLTIP_BEST");
    };

    const locale = i18n.language === 'pt-BR' ? 'pt-BR' : 'en-US';

    return (
        <div className="pacotes-pontos-component">

            <div className="row ajuste-header-mobile">
                <div className="col-12 text-right">
                    <h6 className="sair" onClick={() => navigate('/loja')}>
                        {t("PACKAGES_CLOSE")}
                    </h6>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <h3 className="text-center">{t("PACKAGES_TITLE")}</h3>
                    <p className="text-center text-muted">{t("PACKAGES_SUBTITLE")}</p>
                </div>
            </div>

            <br />

            {!carregouProdutos && produtos.length === 0 && (
                <div className="row">
                    <div className="col-12 text-center">
                        <span>{t("PACKAGES_LOADING")}</span>
                    </div>
                </div>
            )}

            {carregouProdutos && produtos.length === 0 && (
                <div className="row">
                    <div className="col-12 text-center">
                        <span>{t("PACKAGES_EMPTY")}</span>
                    </div>
                </div>
            )}

            {carregouProdutos && produtos.length > 0 && (
                <div className="row tabela-scroll">
                    <div className="col-12">
                        <table className="table table-bordered text-center">
                            <thead>
                                <tr>
                                    <th>{t("PACKAGES_TABLE_PACKAGE")}</th>
                                    <th>{t("PACKAGES_TABLE_POINTS")}</th>
                                    <th>{t("PACKAGES_TABLE_PRICE")}</th>
                                    <th>{t("PACKAGES_TABLE_BUY")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {produtos.map((p, i) => (
                                    <tr key={i} className={p === melhorPacote ? 'linha-melhor-pacote' : ''}>
                                        <td title={tooltipPorPacote(p.Titulo)}>
                                            {p.Titulo}

                                            {p.Titulo.includes("Básico") && (
                                                <span className="badge badge-secondary ml-2">
                                                    {t("PACKAGES_BADGE_BEGINNER")}
                                                </span>
                                            )}

                                            {p.Titulo.includes("Médio") && (
                                                <span className="badge badge-info ml-2">
                                                    {t("PACKAGES_BADGE_POPULAR")}
                                                </span>
                                            )}

                                            {p.Titulo.includes("Avançado") && (
                                                <span className="badge badge-warning ml-2">
                                                    {t("PACKAGES_BADGE_BEST_COST")}
                                                </span>
                                            )}

                                            {p === melhorPacote && (
                                                <span className="badge badge-success ml-2">
                                                    {t("PACKAGES_BADGE_MOST_ADVANTAGE")}
                                                </span>
                                            )}
                                        </td>

                                        <td title={t("PACKAGES_POINTS_TOOLTIP")}>
                                            {p.TotalPontos}
                                        </td>

                                        <td title={t("PACKAGES_PRICE_TOOLTIP")}>
                                            {p.Preco.toLocaleString(locale, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })}
                                        </td>

                                        <td title={t("PACKAGES_BUY_TOOLTIP")}>
                                            <button
                                                disabled={carregouProdutoAposClick}
                                                onClick={() => solicitarCompra(p)}
                                                className="btn btn-compra"
                                            >
                                                {t("PACKAGES_BUY_BUTTON")}
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            <div className="row">
                <div className="col-12 text-left">
                    <h6 className="destaque-mensagem">{t("PACKAGES_CONFIRM_TITLE")}</h6>
                    <span>{t("PACKAGES_CONFIRM_TEXT")}</span>
                </div>
            </div>

            <hr />

            <div className="row">
                <div className="col-12 text-left">
                    <h6 className="destaque-mensagem">{t("PACKAGES_PROBLEM_TITLE")}</h6>
                    <span>{t("PACKAGES_PROBLEM_TEXT")}</span>
                </div>
            </div>

        </div>
    );
};

export { PacotesPontosComponent };
